import MultiplePlaylistsPage from './MultiplePlaylistsPage'

export default MultiplePlaylistsPage
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsPage'
